import { animate, scroll, ScrollOffset } from "motion";

(function () {
  let element = null;

  document.addEventListener("DOMContentLoaded", () => {
    element = document.querySelector("#Hero");

    if (element) {
      scroll(animate(element, { opacity: [0, 1, 1, 0] }),
      { target: element, offset: [...ScrollOffset.Enter, ...ScrollOffset.Exit] });
    }
  });
})();